import { isEmpty, map } from 'ramda';
import { renameKeys } from '@/helpers/common';
import type { CurrencyCode } from '@/helpers/currency';
import type {
  CMSApiBase,
  CMSGeneralButtonType,
  CMSGroupParams,
  CMSImageBase,
  CMSOrder,
  CMSScheduler,
  CMSToggle,
} from './base';

export enum BonusGroupMode {
  AND = 'AND',
  OR = 'OR',
}

export enum BonusType {
  ALL = 'all',
  CASINO = 'casino',
  SPORTS = 'sports',
}

export type UpTo = {
  currency: CurrencyCode;
  amount: number;
}[];

export interface BonusMinDepV2 {
  currency: string;
  amount: number;
}

export interface IBonusSpinValue extends BonusMinDepV2 {}

export interface BonusOrigin
  extends CMSApiBase,
    CMSGroupParams,
    CMSOrder,
    CMSToggle,
    CMSScheduler {
  title: string;
  offer: string | null;
  offerPercent: number | null;
  offerFreespins: number | null;
  upTo: UpTo | null;
  minDep: string | null;
  minDepV2: BonusMinDepV2[];
  maxCashout: string | null;
  maxWinFs: string | null;
  wager: number | null;
  specialNote: string | null;
  code: string | null;
  promoText: string | null;
  buttonType: CMSGeneralButtonType;
  buttonLink: string | null;
  termsAndConditions: string;
  frequency: string | null;
  image?: CMSImageBase;
  typeOffer: BonusType;

  // workaround
  groupsInclude_: string | null;
  groupsExclude_: string | null;
}

export interface CMSBonus
  extends CMSApiBase,
    CMSGroupParams,
    CMSOrder,
    CMSToggle,
    CMSScheduler {
  title: string;
  offer: string | null;
  offerPercent: number | null;
  offerFreespins: number | null;
  upTo: UpTo | null;
  minDep: string | null;
  minDepV2: BonusMinDepV2[];
  maxCashout: string | null;
  maxWinFs: string | null;
  wager: number | null;
  specialNote: string | null;
  code: string | null;
  promoText: string | null;
  buttonType: CMSGeneralButtonType;
  buttonLink: string | null;
  termsAndConditions: string;
  frequency: string | null;
  image?: CMSImageBase;
  identifier?: string;
  starsAnimation?: boolean;
  typeOffer: BonusType;
  spinValue?: IBonusSpinValue[];
  groupKey?: string;
}

export const normalizeBonuses = map<BonusOrigin, CMSBonus>((bonus) => {
  const groupsToRename: {
    [key: string]: string;
  } = {
    ...(!bonus.groupsExclude && { groupsExclude_: 'groupsExclude' }),
    ...(!bonus.groupsInclude && { groupsInclude_: 'groupsInclude' }),
  };

  if (!isEmpty(groupsToRename)) return renameKeys(groupsToRename)(bonus);

  return bonus;
});
